/**
 * Coure.Hub.Service.Plan
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DaysofTheWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const DaysofTheWeek = {
    NUMBER_0: 0 as DaysofTheWeek,
    NUMBER_1: 1 as DaysofTheWeek,
    NUMBER_2: 2 as DaysofTheWeek,
    NUMBER_3: 3 as DaysofTheWeek,
    NUMBER_4: 4 as DaysofTheWeek,
    NUMBER_5: 5 as DaysofTheWeek,
    NUMBER_6: 6 as DaysofTheWeek,
    NUMBER_7: 7 as DaysofTheWeek
};